// import React, { useMemo, useState } from "react";
// import styled from "styled-components";
// import { ContentFrame, colors } from "src/styles";
// import { Container, Content } from "../styles";
// import ServiceTypeQuestion from "../../ServiceTypeQuestion";
// import { CustomWorkRequestFieldsForm } from "./CustomWorkRequestFieldsForm";
// import WorkRequestResourceInput from "./WorkRequestResourceInput";
// import { getAllActiveResources } from "src/redux/selectors/resources";
// import { useSelector } from "react-redux";
// import { UploadWorkOrderAttachments } from "../../UploadWorkOrderAttachments";
// import { EmailToForm } from "./EmailToForm";
// import BackButton from "src/components/Button/BackButton";
// import { ManagerCreateFormFieldsProps } from "../types";
// import WorkRequestTargetDatesInput from "./WorkRequestTargetDatesInput";
// import Button from "src/components/Button";
// import { objToArray } from "src/utils/objToArray";

// const ManagerCreateFormFields = ({
//   formData,
//   isVerifyMode,
//   setFormData,
//   clients,
//   clientId,
//   locations,
//   setClientId,
//   serviceTypes,
//   workTypes,
//   setServiceTypeId,
//   serviceTypeId,
//   priorityLevels,
//   setClassificationId,
//   serviceTypeQuestions,
//   customWorkRequestFields,
//   form,
//   setIsResourceAssignedModalVisible,
//   assignResourceValues,
//   setFiles,
//   files,
//   onExitClick,
//   maximoTimezone,
//   targetFinish,
//   targetStart,
//   timezone,
//   buttonDisabledConditions,
//   error,
//   isLoading,
//   onConfirmClick,
//   onSubmit,
//   setIsVerifyMode,
// }: ManagerCreateFormFieldsProps) => {
//   const [isVerifyChecked, setIsVerifyChecked] = useState(false);
//   const activeResources = useSelector(getAllActiveResources);

//   const serviceTypeOptions = useMemo(() => {
//     const source = serviceTypes?.[clientId] || [];
//     return source
//       .filter(
//         (item) =>
//           item.showOnPublic !== false &&
//           Object.values(item.classifications || {}).some((classification) => classification?.showOnPublic !== false),
//       )
//       .map((item) => ({
//         id: item.id,
//         label: item.description || item.name,
//       }));
//   }, [serviceTypes, clientId]);

//   const classificationOptions = useMemo(() => {
//     const selectedServiceType = serviceTypes?.[clientId]?.find((serviceType) => serviceType.id === serviceTypeId);
//     return objToArray(selectedServiceType?.classifications, (item, id) => ({
//       ...(item || {}),
//       id,
//     }))
//       .filter((item) => !!item?.name)
//       .map((item) => ({
//         id: item.name as string,
//         label: item.description || item.name,
//       }));
//   }, [serviceTypes, clientId, serviceTypeId]);

//   const locationOptions = useMemo(
//     () => locations.filter((location) => String(location.clientId) === String(clientId)),
//     [locations, clientId],
//   );

//   const priorityOptions = useMemo(
//     () => [...(priorityLevels?.[clientId] || [])].sort((a, b) => a.priority - b.priority),
//     [priorityLevels, clientId],
//   );

//   return (
//     <Container>
//       <Content>
//         <BackButton backHandler={onExitClick} />
//         <ContentFrame>
//           <PageRoot>
//             <HeaderArea>
//               <EyebrowText>Intake</EyebrowText>
//               <PageTitle>Create New Work Request</PageTitle>
//               <PageSubtitle>Structured intake. Each section initiates a workflow event.</PageSubtitle>
//             </HeaderArea>

//             <SectionRow>
//               <SectionMeta>
//                 <SectionIndex>01</SectionIndex>
//                 <SectionTitle>Overview</SectionTitle>
//               </SectionMeta>
//               <SectionBody>
//                 <Field>
//                   <FieldLabel>Title *</FieldLabel>
//                   <FieldInput
//                     disabled={isVerifyMode}
//                     placeholder="e.g. HVAC unit failure - Level 3 East"
//                     value={formData.ticketName}
//                     onChange={(e) => setFormData((data) => ({ ...data, ticketName: e.target.value }))}
//                   />
//                 </Field>

//                 <Field>
//                   <FieldLabel>Client *</FieldLabel>
//                   <FieldSelect disabled={isVerifyMode} value={clientId} onChange={(e) => setClientId(e.target.value)}>
//                     <option value="">Select client...</option>
//                     {clients.map((client) => (
//                       <option key={client.id} value={client.id}>
//                         {client.name}
//                       </option>
//                     ))}
//                   </FieldSelect>
//                 </Field>

//                 <Field>
//                   <FieldLabel>Location *</FieldLabel>
//                   <FieldSelect
//                     disabled={isVerifyMode || !clientId}
//                     value={formData.location}
//                     onChange={(e) => setFormData((data) => ({ ...data, location: e.target.value }))}
//                   >
//                     <option value="">Select location...</option>
//                     {locationOptions.map((location) => (
//                       <option key={location.id} value={location.id}>
//                         {location.label || location.address}
//                       </option>
//                     ))}
//                   </FieldSelect>
//                 </Field>
//               </SectionBody>
//             </SectionRow>

//             <SectionRow>
//               <SectionMeta>
//                 <SectionIndex>02</SectionIndex>
//                 <SectionTitle>Classification</SectionTitle>
//               </SectionMeta>
//               <SectionBody>
//                 <Field>
//                   <FieldLabel>Work Type *</FieldLabel>
//                   <SegmentedRow>
//                     {workTypes.map((option) => {
//                       const isActive = formData.workTypeName === option.name;
//                       return (
//                         <SegmentedButton
//                           key={option.name}
//                           type="button"
//                           disabled={isVerifyMode || !clientId}
//                           $isActive={isActive}
//                           onClick={() =>
//                             setFormData((data) => ({
//                               ...data,
//                               workTypeName: option.name,
//                               workType: option.type,
//                             }))
//                           }
//                         >
//                           {option.name}
//                         </SegmentedButton>
//                       );
//                     })}
//                   </SegmentedRow>
//                 </Field>
//                 <Field>
//                   <FieldLabel>Service Type *</FieldLabel>
//                   <FieldSelect
//                     disabled={isVerifyMode || !clientId}
//                     value={serviceTypeId}
//                     onChange={(e) => {
//                       const selectedId = e.target.value;
//                       setServiceTypeId(selectedId);
//                       setFormData((data) => ({
//                         ...data,
//                         serviceType: selectedId,
//                         classification: "",
//                         priority: 0,
//                         priorityName: "",
//                       }));
//                       setClassificationId("");
//                     }}
//                   >
//                     <option value="">Select service type...</option>
//                     {serviceTypeOptions.map((serviceType) => (
//                       <option key={serviceType.id} value={serviceType.id}>
//                         {serviceType.label}
//                       </option>
//                     ))}
//                   </FieldSelect>
//                 </Field>

//                 <Field>
//                   <FieldLabel>Classification *</FieldLabel>
//                   <FieldSelect
//                     disabled={isVerifyMode || !serviceTypeId}
//                     value={formData.classification}
//                     onChange={(e) => {
//                       const selectedClassification = classificationOptions.find(
//                         (item) => item.label === e.target.value,
//                       );
//                       setFormData((data) => ({ ...data, classification: e.target.value }));
//                       setClassificationId(selectedClassification?.id || "");
//                     }}
//                   >
//                     <option value="">Select classification...</option>
//                     {classificationOptions.map((classification) => (
//                       <option key={classification.id} value={classification.label}>
//                         {classification.label}
//                       </option>
//                     ))}
//                   </FieldSelect>
//                 </Field>

//                 {/* <Field>
//                   <FieldLabel>Work Type *</FieldLabel>
//                   <FieldSelect
//                     disabled={isVerifyMode}
//                     value={formData.workType}
//                     onChange={(e) => setFormData((data) => ({ ...data, workType: e.target.value }))}
//                   >
//                     <option value="">Select work type...</option>
//                     {workTypes.map((workType) => (
//                       <option key={workType.id} value={workType.type}>
//                         {workType.name}
//                       </option>
//                     ))}
//                   </FieldSelect>
//                 </Field> */}

//                 <Field>
//                   <FieldLabel>Priority *</FieldLabel>
//                   <SegmentedRow>
//                     {priorityOptions.map((option) => {
//                       const isActive = formData.priorityName === option.name;
//                       return (
//                         <SegmentedButton
//                           key={option.name}
//                           type="button"
//                           disabled={isVerifyMode || !clientId}
//                           $isActive={isActive}
//                           onClick={() =>
//                             setFormData((data) => ({
//                               ...data,
//                               priorityName: option.name,
//                               priority: option.priority,
//                               hoursDelay: option.hoursDelay,
//                             }))
//                           }
//                         >
//                           {option.name}
//                         </SegmentedButton>
//                       );
//                     })}
//                   </SegmentedRow>
//                 </Field>
//               </SectionBody>
//             </SectionRow>

//             {!!serviceTypeQuestions.length && (
//               <SectionRow>
//                 <SectionMeta>
//                   <SectionIndex>03</SectionIndex>
//                   <SectionTitle>Service Questions</SectionTitle>
//                 </SectionMeta>
//                 <SectionBody>
//                   {serviceTypeQuestions.map((question) => (
//                     <ServiceTypeQuestion
//                       key={question.id}
//                       question={question}
//                       formData={formData}
//                       setFormData={setFormData}
//                       disabled={isVerifyMode}
//                     />
//                   ))}
//                 </SectionBody>
//               </SectionRow>
//             )}

//             <SectionRow>
//               <SectionMeta>
//                 <SectionIndex>04</SectionIndex>
//                 <SectionTitle>Details</SectionTitle>
//               </SectionMeta>
//               <SectionBody>
//                 <Field>
//                   <FieldLabel>Description *</FieldLabel>
//                   <FieldTextArea
//                     disabled={isVerifyMode}
//                     value={formData.description}
//                     onChange={(e) => setFormData((data) => ({ ...data, description: e.target.value }))}
//                     placeholder="Describe what happened and any access/scheduling notes"
//                   />
//                 </Field>
//                 <Field>
//                   <FieldLabel>Attachments</FieldLabel>
//                   <UploadWorkOrderAttachments setFiles={setFiles} files={files} isViewMode={isVerifyMode} />
//                 </Field>
//               </SectionBody>
//             </SectionRow>

//             <SectionRow>
//               <SectionMeta>
//                 <SectionIndex>05</SectionIndex>
//                 <SectionTitle>Control</SectionTitle>
//               </SectionMeta>
//               <SectionBody>
//                 {customWorkRequestFields && (
//                   <CustomWorkRequestFieldsForm
//                     customWorkRequestFields={customWorkRequestFields[clientId] ?? []}
//                     $isMobile={false}
//                     form={form}
//                     isPublic={false}
//                     isClient={false}
//                   />
//                 )}

//                 <WorkRequestResourceInput
//                   activeResources={activeResources}
//                   isVerifyMode={isVerifyMode}
//                   setIsResourceAssignedModalVisible={setIsResourceAssignedModalVisible}
//                   assignResourceValues={assignResourceValues}
//                 />

//                 <EmailToForm isManager={true} form={form} $isMobile={false} disabled={isVerifyMode} />

//                 <WorkRequestTargetDatesInput
//                   isVerifyMode={isVerifyMode}
//                   maximoTimezone={maximoTimezone}
//                   targetFinish={targetFinish}
//                   targetStart={targetStart}
//                   timezone={timezone}
//                 />

//                 {!!error && <InlineError>{error}</InlineError>}

//                 {isVerifyMode && (
//                   <VerifyRow>
//                     <input
//                       id="verify-checkbox"
//                       type="checkbox"
//                       checked={isVerifyChecked}
//                       onChange={(e) => setIsVerifyChecked(e.target.checked)}
//                     />
//                     <label htmlFor="verify-checkbox">I verify the above entered details to be true and correct.</label>
//                   </VerifyRow>
//                 )}

//                 <ActionsRow>
//                   <Button
//                     text={isVerifyMode ? "Back to Edit" : "Cancel"}
//                     variant="secondary"
//                     onClick={isVerifyMode ? () => setIsVerifyMode(false) : onExitClick}
//                   />
//                   <PrimaryActionButton
//                     type="button"
//                     disabled={isVerifyMode ? !isVerifyChecked : buttonDisabledConditions || isLoading}
//                     onClick={(e) => {
//                       if (isVerifyMode) {
//                         onSubmit(e);
//                       } else {
//                         onConfirmClick(e as React.MouseEvent<HTMLButtonElement>);
//                       }
//                     }}
//                   >
//                     {isLoading ? "Submitting..." : isVerifyMode ? "Submit Request" : "Create Request"}
//                   </PrimaryActionButton>
//                 </ActionsRow>
//               </SectionBody>
//             </SectionRow>
//           </PageRoot>
//         </ContentFrame>
//       </Content>
//     </Container>
//   );
// };

// const PageRoot = styled.div`
//   max-width: 1080px;
//   margin: 0 auto;
//   padding-bottom: 32px;
// `;

// const HeaderArea = styled.div`
//   padding-bottom: 24px;
//   border-bottom: 1px solid #dde2e7;
// `;

// const EyebrowText = styled.div`
//   font-size: 11px;
//   letter-spacing: 0.04em;
//   text-transform: uppercase;
//   color: #6f7782;
// `;

// const PageTitle = styled.h1`
//   margin: 8px 0 0;
//   font-size: 40px;
//   line-height: 1.1;
//   font-weight: 600;
//   color: #1f2a37;
// `;

// const PageSubtitle = styled.p`
//   margin: 8px 0 0;
//   font-size: 13px;
//   color: #6f7782;
// `;

// const SectionRow = styled.section`
//   display: grid;
//   grid-template-columns: 260px 1fr;
//   gap: 48px;
//   padding: 40px 0;
//   border-top: 1px solid #dde2e7;

//   @media (max-width: 1024px) {
//     grid-template-columns: 1fr;
//     gap: 20px;
//   }
// `;

// const SectionMeta = styled.div``;

// const SectionIndex = styled.div`
//   font-size: 11px;
//   color: #6f7782;
//   letter-spacing: 0.04em;
// `;

// const SectionTitle = styled.h2`
//   margin: 8px 0 0;
//   font-size: 20px;
//   line-height: 1.25;
//   color: #1f2a37;
// `;

// const SectionBody = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 28px;
// `;

// const Field = styled.div``;

// const FieldLabel = styled.label`
//   display: block;
//   margin-bottom: 8px;
//   font-size: 12px;
//   text-transform: uppercase;
//   letter-spacing: 0.08em;
//   color: #1f2a37;
//   font-weight: 600;
// `;

// const FieldInput = styled.input`
//   width: 100%;
//   border: 1px solid #c9d2dc;
//   padding: 14px 16px;
//   font-size: 14px;
//   background: #ffffff;

//   &:focus {
//     outline: 1px solid #1f2a37;
//     outline-offset: -1px;
//   }
// `;

// const FieldTextArea = styled.textarea`
//   width: 100%;
//   min-height: 140px;
//   border: 1px solid #c9d2dc;
//   padding: 14px 16px;
//   font-size: 14px;
//   resize: vertical;

//   &:focus {
//     outline: 1px solid #1f2a37;
//     outline-offset: -1px;
//   }
// `;

// const FieldSelect = styled.select`
//   width: 100%;
//   border: 1px solid #c9d2dc;
//   padding: 14px 16px;
//   font-size: 14px;
//   background: #ffffff;

//   &:focus {
//     outline: 1px solid #1f2a37;
//     outline-offset: -1px;
//   }
// `;

// const SegmentedRow = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   gap: 10px;
// `;

// const SegmentedButton = styled.button<{ $isActive: boolean }>`
//   border: 1px solid ${({ $isActive }) => ($isActive ? "#1f2a37" : "#c9d2dc")};
//   background: ${({ $isActive }) => ($isActive ? "#1f2a37" : "#ffffff")};
//   color: ${({ $isActive }) => ($isActive ? "#ffffff" : "#1f2a37")};
//   padding: 10px 16px;
//   font-size: 12px;
//   font-weight: 600;
//   text-transform: uppercase;
//   letter-spacing: 0.08em;
// `;

// const InlineError = styled.p`
//   margin: 0;
//   color: ${colors.red.default};
//   font-size: 13px;
// `;

// const VerifyRow = styled.label`
//   display: flex;
//   gap: 10px;
//   align-items: center;
//   font-size: 13px;
//   color: #1f2a37;

//   input {
//     width: 16px;
//     height: 16px;
//   }
// `;

// const ActionsRow = styled.div`
//   display: flex;
//   gap: 12px;
//   align-items: center;
// `;

// const PrimaryActionButton = styled.button`
//   border: 1px solid #1f2a37;
//   background: #1f2a37;
//   color: #ffffff;
//   padding: 12px 22px;
//   font-size: 12px;
//   text-transform: uppercase;
//   letter-spacing: 0.1em;
//   font-weight: 600;

//   &:disabled {
//     border-color: #c9d2dc;
//     background: #c9d2dc;
//     cursor: not-allowed;
//   }
// `;

// export default ManagerCreateFormFields;

import React, { useEffect, useMemo, useState } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "src/styles/datepicker-overrides.css";
import styled from "styled-components";
import { ContentFrame, colors } from "src/styles";
import { Container, Content } from "../styles";
import { AttachmentPickerModal } from "../../AttachmentPickerModal";
import ServiceTypeQuestion from "../../ServiceTypeQuestion";
import { CustomWorkRequestFieldsForm } from "./CustomWorkRequestFieldsForm";
import BackButton from "src/components/Button/BackButton";
import { ManagerCreateFormFieldsProps } from "../types";
import WorkRequestTargetDatesInput from "./WorkRequestTargetDatesInput";
import Button from "src/components/Button";
import { objToArray } from "src/utils/objToArray";
import { getServiceTypesForClient, normalizeHighRiskClassifications } from "src/utils/serviceTypes";
import { MaximoDocument, ResourceKind, Ticket } from "src/types";
import { getAllActiveResources } from "src/redux/selectors/resources";
import { useSelector } from "react-redux";
import { ClientSelectionModal } from "./ClientSelectionModal";
import { ParentWorkOrderSelectionModal } from "./ParentWorkOrderSelectionModal";
import { ServiceTypeClassificationModal } from "./ServiceTypeClassificationModal";
import WorkRequestCommentInput from "./WorkRequestCommentInput";
import { AssetSelectionModal } from "./AssetSelectionModal";
import { RelatedResourceSelectionModal } from "./RelatedResourceSelectionModal";
import RequestQuoteForm, { RequestQuoteFormData } from "src/pages/TicketForm/RequestQuoteForm";
import { RecurringScheduleModal } from "./RecurringScheduleModal";
import { RecurringSchedule } from "../types";

const parseLocalDateTime = (value?: string) => {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const formatDateTimeLocalValue = (date: Date | null) => {
  if (!date) return "";
  const pad = (num: number) => String(num).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(
    date.getMinutes(),
  )}`;
};

const DateTimePickerInput = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  (props, ref) => <FieldInput {...props} ref={ref} readOnly />,
);

DateTimePickerInput.displayName = "DateTimePickerInput";

interface ExtendedManagerCreateFormFieldsProps extends ManagerCreateFormFieldsProps {
  assets?: Array<{ id: string; name: string; locationId: string | number }>;
  contacts?: Array<{ id: string; name: string }>;
  // Billing additions passed from parent/orchestrator context if applicable
  showBillingSection?: boolean;
  costPlusPct?: number | null;
  selectedClient?: { name: string } | null;
  computedClientAmount?: { amount: number | null } | null;
  fmtMoney?: (val: number) => string;
  lastWorkOrderNumber?: string | null;
  existingWorkOrders?: Ticket[];
}

const ManagerCreateFormFields = ({
  formData,
  isVerifyMode,
  setFormData,
  clients,
  clientId,
  locations,
  setClientId,
  serviceTypes,
  workTypes,
  setServiceTypeId,
  serviceTypeId,
  priorityLevels,
  setClassificationId,
  serviceTypeQuestions,
  customWorkRequestFields,
  form,
  setIsResourceAssignedModalVisible: _setIsResourceAssignedModalVisible,
  setAssignResourceValues,
  setFiles,
  files,
  onExitClick,
  highRiskClassifications = [],
  maximoTimezone,
  targetFinish,
  targetStart,
  timezone,
  buttonDisabledConditions,
  error,
  isLoading,
  onConfirmClick,
  // onSubmit,
  // setIsVerifyMode,
  assets = [],
  // Fallbacks for the new reference parameters to safely avoid crash runtime errors
  showBillingSection = true,
  costPlusPct = null,
  selectedClient = null,
  computedClientAmount = null,
  fmtMoney = (val) => `$${Number(val).toFixed(2)}`,
  lastWorkOrderNumber = null,
  existingWorkOrders = [],
}: ExtendedManagerCreateFormFieldsProps) => {
  const toDigitsOnly = (value: string) => value.replace(/\D/g, "");
  const toNumberOrNull = (value: string | number | null | undefined) => {
    if (value === "" || value == null) return null;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  };

  const getAutoCalculatedClientFixedAmount = (vendorCostValue: string | number, markupPctValue: string | number) => {
    const vendorCostNumber = toNumberOrNull(vendorCostValue);
    const markupPctNumber = toNumberOrNull(markupPctValue);

    if (vendorCostNumber == null || markupPctNumber == null) {
      return null;
    }

    return (vendorCostNumber * (1 + markupPctNumber / 100)).toFixed(2);
  };

  const [isClientModalOpen, setIsClientModalOpen] = useState(false);
  const [isParentModalOpen, setIsParentModalOpen] = useState(false);
  const [isServiceTypeModalOpen, setIsServiceTypeModalOpen] = useState(false);
  const [isAssetModalOpen, setIsAssetModalOpen] = useState(false);
  const [isRelatedResourceModalOpen, setIsRelatedResourceModalOpen] = useState(false);
  const [isRecurringScheduleModalOpen, setIsRecurringScheduleModalOpen] = useState(false);
  const [isHighRiskClassificationModalOpen, setIsHighRiskClassificationModalOpen] = useState(false);
  const [isAttachmentModalOpen, setIsAttachmentModalOpen] = useState(false);
  const [pendingAttachmentFiles, setPendingAttachmentFiles] = useState<MaximoDocument[]>([]);
  const activeResources = useSelector(getAllActiveResources);
  const [isQuoteModalVisible, setIsQuoteModalVisible] = useState<boolean>(false);

  // ─── Related Resource Original Local State (PRESERVED) ────────────────────
  const [resourceKind, setResourceKind] = useState<ResourceKind>("none");
  const [resourceId, setResourceId] = useState("");

  const openAttachmentModal = () => {
    setPendingAttachmentFiles(files);
    setIsAttachmentModalOpen(true);
  };

  const closeAttachmentModal = () => {
    setPendingAttachmentFiles([]);
    setIsAttachmentModalOpen(false);
  };

  const onAttachmentFilesSelected = (selectedFiles: FileList | null) => {
    const picked = Array.from(selectedFiles ?? []);

    if (!picked.length) {
      return;
    }

    setPendingAttachmentFiles((currentFiles) => [
      ...currentFiles,
      ...picked.map((file) => ({
        description: file.name,
        fileName: file.name,
        href: URL.createObjectURL(file),
        attachmentId: "",
        file,
      })),
    ]);
  };

  const getSelectionResourceId = (resource: any, kind: ResourceKind) => {
    if (kind === "vendor") {
      return String(resource?.id || resource?.vendorId || "");
    }

    if (kind === "team_member") {
      return String(resource?.id || resource?.laborCode || "");
    }

    return "";
  };

  // ─── Client Modal Handlers ────────────────────────────────────────────────
  const handleClientModalConfirm = (selectedClientId: string, selectedLocationId: string) => {
    const normalizedClientId = String(selectedClientId || "");
    const normalizedLocationId = String(selectedLocationId || "");

    setClientId(normalizedClientId);
    setFormData((data) => {
      const hasSelectionChanged =
        String(clientId || "") !== normalizedClientId || String(data.location || "") !== normalizedLocationId;

      return {
        ...data,
        location: normalizedLocationId,
        recurringSchedule: hasSelectionChanged ? undefined : data.recurringSchedule,
      };
    });
    setIsClientModalOpen(false);
  };

  const selectedClientName = useMemo(() => {
    return clients.find((c) => c.id === clientId)?.name || "Select Client";
  }, [clientId, clients]);

  const selectedClientRecord = useMemo(
    () => clients.find((client) => String(client.id) === String(clientId)),
    [clients, clientId],
  );

  const selectedLocationRecord = useMemo(
    () => locations.find((location) => String(location.id) === String(formData.location)),
    [locations, formData.location],
  );

  const quotePrefillData = useMemo<Partial<RequestQuoteFormData>>(() => {
    const locationContact = Object.values(selectedLocationRecord?.contacts || {})[0];
    const billAttentionTo = [selectedClientRecord?.firstName, selectedClientRecord?.lastName]
      .filter(Boolean)
      .join(" ")
      .trim();
    const shipAttentionTo = [locationContact?.firstName, locationContact?.lastName].filter(Boolean).join(" ").trim();

    return {
      billTo: {
        attentionTo: billAttentionTo,
        client: selectedClientRecord?.name || "",
        address: selectedClientRecord?.address || "",
      },
      shipTo: {
        sameAsAddress: false,
        attentionTo: shipAttentionTo,
        client: selectedLocationRecord?.label || "",
        address: selectedLocationRecord?.address || "",
      },
    };
  }, [selectedClientRecord, selectedLocationRecord]);

  const vendorResources = activeResources.vendors || [];
  const teamResources = activeResources.employees || [];
  const isRecurringService = formData.serviceMode === "recurring";
  const resourceOptions = useMemo(() => {
    if (resourceKind === "vendor") {
      return vendorResources.filter((resource) => {
        if (!resource.vendorId) return false;
        return resource.clients?.length !== 0 && resource.clients?.includes(clientId);
      });
    }
    if (resourceKind === "team_member") {
      return teamResources;
    }
    return [];
  }, [resourceKind, vendorResources, teamResources, clientId]);

  const relatedResourceModalOptions = useMemo(
    () =>
      resourceOptions.map((resource) => ({
        id: getSelectionResourceId(resource, resourceKind),
        name: resource.displayName || resource.name || "Unnamed",
        details:
          resourceKind === "vendor" ? `Vendor ID: ${resource.vendorId || "-"}` : resource.email || "No email on file",
      })),
    [resourceOptions, resourceKind],
  );

  const selectedResourceLabel = useMemo(() => {
    if (resourceKind === "none" || !resourceId) return "";
    const selectedResource = resourceOptions.find(
      (resource) => getSelectionResourceId(resource, resourceKind) === String(resourceId),
    );
    return selectedResource ? selectedResource.displayName || "Unnamed" : "";
  }, [resourceKind, resourceId, resourceOptions]);

  useEffect(() => {
    if (resourceKind === "none" || !resourceId) {
      setAssignResourceValues(undefined);
      return;
    }

    if (resourceKind === "vendor") {
      const selectedVendor = vendorResources.find(
        (vendor) => getSelectionResourceId(vendor, "vendor") === String(resourceId),
      );

      if (!selectedVendor?.vendorId) {
        setAssignResourceValues(undefined);
        return;
      }

      setAssignResourceValues({
        activetab: "vendors",
        employees: {},
        vendors: {
          id: selectedVendor.id,
          vendorId: selectedVendor.vendorId,
          vendorName: selectedVendor.displayName || selectedVendor.vendorId,
          woacceptscharges: true,
        },
      });
      return;
    }

    const selectedEmployee = teamResources.find(
      (employee) => getSelectionResourceId(employee, "team_member") === String(resourceId),
    );

    if (!selectedEmployee?.laborCode) {
      setAssignResourceValues(undefined);
      return;
    }

    setAssignResourceValues({
      activetab: "employees",
      employees: {
        id: selectedEmployee.id,
        laborCode: selectedEmployee.laborCode,
        displayName: selectedEmployee.displayName,
        email: selectedEmployee.email,
      },
      vendors: {
        woacceptscharges: false,
      },
    });
  }, [resourceKind, resourceId, setAssignResourceValues, teamResources, vendorResources]);

  // const assignedVendor = useMemo(() => {
  //   if (resourceKind !== "vendor" || !resourceId) return undefined;
  //   return vendorResources.find((resource) => resource.id === resourceId);
  // }, [resourceKind, resourceId, vendorResources]);

  // const assignedEmployee = useMemo(() => {
  //   if (resourceKind !== "team_member" || !resourceId) return undefined;
  //   return teamResources.find((resource) => resource.id === resourceId);
  // }, [resourceKind, resourceId, teamResources]);

  // ─── Conditional Billing Visibility Computations ──────────────────────────
  const isKsiOnly = formData.billingType === "ksi";
  const isClientBilled = formData.billingType === "client" || formData.billingType === "both";
  const isBoth = formData.billingType === "both";
  const isClientOnly = formData.billingType === "client";
  // Safe default helper to mimic conditional display features from context
  const showVendorCost = true;

  // ─── Derived Options & Mappings ────────────────────────────────────────────
  const serviceTypeOptions = useMemo(() => {
    const source = getServiceTypesForClient(serviceTypes, clientId);
    return source
      .filter(
        (item) =>
          item.showOnPublic !== false &&
          Object.values(item.classifications || {}).some((classification) => classification?.showOnPublic !== false),
      )
      .map((item) => ({
        id: item.id,
        label: item.description || item.name,
      }));
  }, [serviceTypes, clientId]);

  // const classificationOptions = useMemo(() => {
  //   const selectedServiceType = serviceTypes?.[clientId]?.find((serviceType) => serviceType.id === serviceTypeId);
  //   return objToArray(selectedServiceType?.classifications, (item, id) => ({
  //     ...(item || {}),
  //     id,
  //   }))
  //     .filter((item) => !!item?.name)
  //     .map((item) => ({
  //       id: item.name as string,
  //       label: item.description || item.name,
  //     }));
  // }, [serviceTypes, clientId, serviceTypeId]);

  const getClassificationsByServiceType = (selectedServiceTypeId: string) => {
    const selectedServiceType = getServiceTypesForClient(serviceTypes, clientId).find(
      (serviceType) => serviceType.id === selectedServiceTypeId,
    );
    return objToArray(selectedServiceType?.classifications, (item, id) => ({
      ...(item || {}),
      id,
    }))
      .filter((item) => !!item?.name)
      .map((item) => ({
        id: item.name as string,
        label: item.description || item.name || "",
      }));
  };

  const selectedServiceTypeLabel = useMemo(
    () => serviceTypeOptions.find((item) => item.id === serviceTypeId)?.label || "",
    [serviceTypeOptions, serviceTypeId],
  );

  const locationOptions = useMemo(
    () => locations.filter((location) => String(location.clientId) === String(clientId)),
    [locations, clientId],
  );

  const assetOptions = useMemo(
    () => assets.filter((asset) => String(asset.locationId) === String(formData.location)),
    [assets, formData.location],
  );

  const selectedAsset = useMemo(
    () => assets.find((asset) => String(asset.id) === String(formData.assetId)),
    [assets, formData.assetId],
  );

  const priorityOptions = useMemo(
    () => [...(priorityLevels?.[clientId] || [])].sort((a, b) => a.priority - b.priority),
    [priorityLevels, clientId],
  );

  const proposedCompletionDate = useMemo(() => {
    const hoursDelay = Number(formData.hoursDelay);

    if (!formData.priorityName || !Number.isFinite(hoursDelay) || hoursDelay <= 0) {
      return null;
    }

    return new Date(Date.now() + hoursDelay * 60 * 60 * 1000);
  }, [formData.priorityName, formData.hoursDelay]);

  const proposedCompletionLabel = useMemo(() => {
    if (!proposedCompletionDate) return "";

    try {
      return new Intl.DateTimeFormat("en-US", {
        dateStyle: "medium",
        timeStyle: "short",
        ...(timezone ? { timeZone: timezone } : {}),
      }).format(proposedCompletionDate);
    } catch {
      return proposedCompletionDate.toLocaleString();
    }
  }, [proposedCompletionDate, timezone]);

  const parentWorkOrderOptions = useMemo(() => {
    if (!clientId) return existingWorkOrders;

    // Some work-order responses do not always include clientId. Keep those rows available
    // so parent selection does not appear empty.
    return existingWorkOrders.filter(
      (workOrder) => !workOrder.clientId || String(workOrder.clientId) === String(clientId),
    );
  }, [existingWorkOrders, clientId]);

  const selectedParentWorkOrder = useMemo(
    () => parentWorkOrderOptions.find((workOrder) => workOrder.wonum === formData.parentWorkOrder),
    [parentWorkOrderOptions, formData.parentWorkOrder],
  );

  const highRiskServiceTypeId = formData.highRiskServiceTypeId || "";
  const highRiskClassificationId = formData.highRiskClassificationId || "";
  const highRiskClassificationOptions = useMemo(() => {
    const fromProp = normalizeHighRiskClassifications(highRiskClassifications);
    if (fromProp.length) {
      return fromProp;
    }

    const fallback = normalizeHighRiskClassifications(
      (formData as Record<string, unknown>).highRiskClassification ??
        (formData as Record<string, unknown>).highRiskClassifications ??
        [],
    );
    return fallback;
  }, [formData, highRiskClassifications]);

  const highRiskServiceTypeLabel = useMemo(
    () => serviceTypeOptions.find((item) => item.id === highRiskServiceTypeId)?.label || "",
    [serviceTypeOptions, highRiskServiceTypeId],
  );

  const highRiskClassificationLabel = useMemo(() => {
    return highRiskClassificationOptions.find((item) => item.id === highRiskClassificationId)?.label || "";
  }, [highRiskClassificationId, highRiskClassificationOptions]);

  const recurringScheduleLocationCount = formData.recurringSchedule?.locations?.length || 0;

  const recurringScheduleSummary = useMemo(() => {
    const schedule = formData.recurringSchedule;
    if (!schedule || !schedule.locations?.length) {
      return "No recurring schedule configured yet.";
    }

    const cycleLabelMap = {
      one_time: "one time",
      weekly: "weekly",
      biweekly: "every 2 weeks",
      monthly: "monthly",
      quarterly: "every 3 months",
      semiannual: "every 6 months",
      annual: "annually",
    } as const;

    const cycleLabel = cycleLabelMap[schedule.frequency];

    return `${schedule.locations.length} location${schedule.locations.length === 1 ? "" : "s"} scheduled ${cycleLabel} from ${schedule.startDate} to ${schedule.endDate}.`;
  }, [formData.recurringSchedule]);

  return (
    <Container>
      <ClientSelectionModal
        isOpen={isClientModalOpen}
        onClose={() => setIsClientModalOpen(false)}
        onConfirm={handleClientModalConfirm}
        clients={clients}
        locations={locations}
        currentClientId={clientId}
        currentLocationId={formData.location}
      />
      <ParentWorkOrderSelectionModal
        isOpen={isParentModalOpen}
        onClose={() => setIsParentModalOpen(false)}
        workOrders={parentWorkOrderOptions}
        selectedWonum={formData.parentWorkOrder}
        onConfirm={(wonum) => setFormData((data) => ({ ...data, parentWorkOrder: wonum }))}
      />
      <ServiceTypeClassificationModal
        isOpen={isServiceTypeModalOpen}
        onClose={() => setIsServiceTypeModalOpen(false)}
        serviceTypes={serviceTypeOptions}
        selectedServiceTypeId={serviceTypeId}
        // selectedClassificationId={classificationOptions.find((item) => item.label === formData.classification)?.id}
        getClassifications={getClassificationsByServiceType}
        onConfirm={(selectedServiceTypeId, selectedClassificationId) => {
          const selectedClassification = getClassificationsByServiceType(selectedServiceTypeId).find(
            (item) => item.id === selectedClassificationId,
          );
          setServiceTypeId(selectedServiceTypeId);
          setClassificationId(selectedClassificationId);
          setFormData((data) => ({
            ...data,
            serviceType: selectedServiceTypeId,
            classification: selectedClassification?.label || "",
            priority: 0,
            priorityName: "",
          }));
        }}
      />
      <AssetSelectionModal
        isOpen={isAssetModalOpen}
        onClose={() => setIsAssetModalOpen(false)}
        assets={assetOptions}
        selectedAssetId={formData.assetId}
        onConfirm={(assetId) => setFormData((data) => ({ ...data, assetId }))}
      />
      <RelatedResourceSelectionModal
        isOpen={isRelatedResourceModalOpen && resourceKind !== "none"}
        onClose={() => setIsRelatedResourceModalOpen(false)}
        resourceType={resourceKind === "vendor" ? "vendor" : "team_member"}
        resources={relatedResourceModalOptions}
        selectedResourceId={resourceId}
        onConfirm={(selectedResourceId) => {
          setResourceId(selectedResourceId);
          setIsRelatedResourceModalOpen(false);
        }}
      />
      <RecurringScheduleModal
        isOpen={isRecurringScheduleModalOpen}
        onClose={() => setIsRecurringScheduleModalOpen(false)}
        locations={locationOptions}
        activeResources={activeResources}
        clientId={clientId}
        initialSchedule={formData.recurringSchedule as RecurringSchedule | undefined}
        onSave={(schedule) => {
          setFormData((data) => ({
            ...data,
            recurringSchedule: schedule,
          }));
        }}
      />
      <ServiceTypeClassificationModal
        isOpen={isHighRiskClassificationModalOpen}
        onClose={() => setIsHighRiskClassificationModalOpen(false)}
        serviceTypes={highRiskClassificationOptions.map((item) => ({ id: item.id, label: item.label }))}
        selectedServiceTypeId={highRiskClassificationId}
        getClassifications={() => highRiskClassificationOptions.map((item) => ({ id: item.id, label: item.label }))}
        onConfirm={(_selectedServiceTypeId, selectedClassificationId) => {
          const selectedClassification = highRiskClassificationOptions.find(
            (item) => item.id === selectedClassificationId,
          );

          setFormData((data) => ({
            ...data,
            highRiskClassificationId: selectedClassificationId,
            highRiskClassification: selectedClassification?.label || "",
          }));
          setIsHighRiskClassificationModalOpen(false);
        }}
      />
      {isQuoteModalVisible && (
        <QuoteModalOverlay>
          <QuoteModalCard>
            <QuoteModalHeader>
              <h3>Generate Quote</h3>
              <QuoteModalCloseButton type="button" onClick={() => setIsQuoteModalVisible(false)}>
                Close
              </QuoteModalCloseButton>
            </QuoteModalHeader>
            <QuoteModalBody>
              <RequestQuoteForm onCancel={() => setIsQuoteModalVisible(false)} initialData={quotePrefillData} />
            </QuoteModalBody>
          </QuoteModalCard>
        </QuoteModalOverlay>
      )}

      <Content>
        <BackButton backHandler={onExitClick} />
        <ContentFrame>
          <PageRoot>
            <HeaderArea>
              <EyebrowText>Intake</EyebrowText>
              <PageTitle>Create New Work Request</PageTitle>
              <PageSubtitle>Structured intake. Each section initiates a workflow event.</PageSubtitle>

              <ServiceModeToggleRow>
                <ServiceModeButton
                  type="button"
                  disabled={isVerifyMode}
                  $isActive={!isRecurringService}
                  onClick={() =>
                    setFormData((data) => ({
                      ...data,
                      serviceMode: "one_time",
                      recurringSchedule: undefined,
                    }))
                  }
                >
                  One-Time Service
                </ServiceModeButton>
                <ServiceModeButton
                  type="button"
                  disabled={isVerifyMode}
                  $isActive={isRecurringService}
                  onClick={() =>
                    setFormData((data) => ({
                      ...data,
                      serviceMode: "recurring",
                      workTypeName: "",
                      workType: "",
                      priorityName: "",
                      priority: 0,
                      hoursDelay: 0,
                      location: "",
                    }))
                  }
                >
                  Recurring Service
                </ServiceModeButton>
              </ServiceModeToggleRow>
            </HeaderArea>

            {/* ── 01 Overview ── */}
            <SectionRow>
              <SectionMeta>
                <SectionIndex>01</SectionIndex>
                <SectionTitle>Overview</SectionTitle>
              </SectionMeta>
              <SectionBody>
                <Field>
                  <FieldLabel>WONUM *</FieldLabel>
                  {/* <FieldHelper>Auto-generated</FieldHelper> */}
                  <FieldInput
                    disabled={true}
                    value={`WO${Number(lastWorkOrderNumber?.split("O")[1] || 0) + 1 || "Auto-generated on submission"}`}
                    onChange={(e) => setFormData((data) => ({ ...data, ticketName: e.target.value }))}
                  />
                </Field>

                <Field>
                  <FieldLabel>Title *</FieldLabel>
                  {/* <FieldHelper>Short description shown in lists</FieldHelper> */}
                  <FieldInput
                    disabled={isVerifyMode}
                    placeholder="e.g. HVAC unit failure - Level 3 East"
                    value={formData.ticketName}
                    onChange={(e) => setFormData((data) => ({ ...data, ticketName: e.target.value }))}
                  />
                </Field>

                <Field>
                  <FieldLabel>Client & Location *</FieldLabel>
                  {/* <FieldHelper>
                    {isRecurringService
                      ? "Select client and location from the modal. Additional recurring locations are configured in the schedule modal."
                      : "Select client and location from the modal"}
                  </FieldHelper> */}
                  <ClientLocationButton
                    type="button"
                    disabled={isVerifyMode}
                    onClick={() => setIsClientModalOpen(true)}
                    $isEmpty={!clientId}
                  >
                    <ClientLocationButtonText>
                      {!clientId ? "Select Client & Location..." : selectedClientName}
                    </ClientLocationButtonText>
                    <ClientLocationButtonMeta>
                      {(formData.location && locationOptions.find((loc) => loc.id === formData.location)?.label) ||
                        formData.location}
                    </ClientLocationButtonMeta>
                    <ClientLocationButtonChevron>›</ClientLocationButtonChevron>
                  </ClientLocationButton>
                </Field>

                <Field>
                  <FieldLabel>Specific area / room </FieldLabel>
                  {/* <FieldHelper>e.g. &quot;Boiler room B2&quot;, &quot;Roof plant area&quot;</FieldHelper> */}
                  <FieldInput
                    disabled={isVerifyMode}
                    placeholder="e.g. Conference Room A - Level 3 East"
                    value={formData.specificArea}
                    onChange={(e) => setFormData((data) => ({ ...data, specificArea: e.target.value }))}
                  />
                </Field>

                <Field>
                  <FieldLabel>Asset</FieldLabel>
                  {/* <FieldHelper>
                    Separate Jira task set up for how to set up an Asset. Asset being worked on; filtered by location
                  </FieldHelper> */}
                  <ParentWorkOrderButton
                    type="button"
                    disabled={isVerifyMode || !formData.location}
                    onClick={() => setIsAssetModalOpen(true)}
                  >
                    <ParentWorkOrderButtonText>
                      {selectedAsset
                        ? `${selectedAsset.name || "Unnamed asset"}: ${selectedAsset.id}`
                        : "Search and select asset..."}
                    </ParentWorkOrderButtonText>
                    <ParentWorkOrderButtonChevron>›</ParentWorkOrderButtonChevron>
                  </ParentWorkOrderButton>
                  {!!formData.assetId && !isVerifyMode && (
                    <ClearParentLink type="button" onClick={() => setFormData((data) => ({ ...data, assetId: "" }))}>
                      Clear selected asset
                    </ClearParentLink>
                  )}
                </Field>
              </SectionBody>
            </SectionRow>

            {/* ── 04 Details ── */}
            <SectionRow>
              <SectionMeta>
                <SectionIndex>04</SectionIndex>
                <SectionTitle>Details</SectionTitle>
              </SectionMeta>
              <SectionBody>
                <Field>
                  <FieldLabel>Description of work *</FieldLabel>
                  {/* <FieldHelper>Detailed job description</FieldHelper> */}
                  <FieldTextArea
                    disabled={isVerifyMode}
                    value={formData.description}
                    onChange={(e) => setFormData((data) => ({ ...data, description: e.target.value }))}
                    placeholder="Describe what happened and any access/scheduling notes"
                  />
                </Field>

                <WorkRequestCommentInput
                  comment={formData.workRequestComment}
                  isVerifyMode={isVerifyMode}
                  setFormData={setFormData}
                />

                <Field>
                  <FieldLabel>Attachments</FieldLabel>
                  {/* <FieldHelper>PDF, JPG/photos, Excel, Word, etc.</FieldHelper> */}
                  <AttachLabel $disabled={isVerifyMode} onClick={() => !isVerifyMode && openAttachmentModal()}>
                    <AttachText>
                      {files.length === 0
                        ? "No files attached. Drop files here or click to browse."
                        : `${files.length} file${files.length === 1 ? "" : "s"} attached.`}
                    </AttachText>
                    <AttachButton as="span">+ Attach Files</AttachButton>
                  </AttachLabel>
                </Field>
              </SectionBody>
            </SectionRow>

            <AttachmentPickerModal
              isOpen={isAttachmentModalOpen}
              files={pendingAttachmentFiles}
              subtitle="Choose documents or images to include with this work request before you save it."
              confirmText="Done"
              onClose={closeAttachmentModal}
              onConfirm={() => {
                setFiles(pendingAttachmentFiles);
                closeAttachmentModal();
              }}
              onRemove={(index) =>
                setPendingAttachmentFiles((currentFiles) => currentFiles.filter((_, itemIndex) => itemIndex !== index))
              }
              onFilesSelected={onAttachmentFilesSelected}
            />

            {/* ── 02 Classification ── */}
            <SectionRow>
              <SectionMeta>
                <SectionIndex>02</SectionIndex>
                <SectionTitle>Classification</SectionTitle>
              </SectionMeta>
              <SectionBody>
                {!isRecurringService && (
                  <Field>
                    <FieldLabel>Work Type *</FieldLabel>
                    {/* <FieldHelper>
                      Options: Service Request, Service Concern, Other, Capital, KSI, Incident, Inspection
                    </FieldHelper> */}
                    <SegmentedRow>
                      {workTypes.map((option) => {
                        const isActive = formData.workTypeName === option.name;
                        return (
                          <SegmentedButton
                            key={option.name}
                            type="button"
                            disabled={isVerifyMode || !clientId}
                            $isActive={isActive}
                            onClick={() =>
                              setFormData((data) => ({
                                ...data,
                                workTypeName: option.name,
                                workType: option.type,
                              }))
                            }
                          >
                            {option.name}
                          </SegmentedButton>
                        );
                      })}
                    </SegmentedRow>
                  </Field>
                )}

                <Field>
                  <FieldLabel>Service Type *</FieldLabel>
                  {/* <FieldHelper>Links to service catalog</FieldHelper> */}
                  <FieldSelectionButton
                    type="button"
                    disabled={isVerifyMode || !clientId}
                    onClick={() => setIsServiceTypeModalOpen(true)}
                  >
                    <FieldSelectionText>{selectedServiceTypeLabel || "Select service type..."}</FieldSelectionText>
                    <FieldSelectionChevron>›</FieldSelectionChevron>
                  </FieldSelectionButton>
                </Field>

                {!isRecurringService && (
                  <Field>
                    <FieldLabel>Priority *</FieldLabel>
                    {/* <FieldHelper>
                      Options: Emergency (less than 24 hours) / High (1 to 2 days) / Medium (5 to 7 days) / Low (up to
                      one month)
                    </FieldHelper> */}
                    <SegmentedRow>
                      {priorityOptions.map((option) => {
                        const isActive = formData.priorityName === option.name;
                        return (
                          <SegmentedButton
                            key={option.name}
                            type="button"
                            disabled={isVerifyMode || !clientId}
                            $isActive={isActive}
                            onClick={() =>
                              setFormData((data) => ({
                                ...data,
                                priorityName: option.name,
                                priority: option.priority,
                                hoursDelay: option.hoursDelay,
                              }))
                            }
                          >
                            {option.name}
                          </SegmentedButton>
                        );
                      })}
                    </SegmentedRow>

                    {proposedCompletionDate && (
                      <PriorityProjectionCard>
                        <PriorityProjectionLabel>Proposed Completion Date</PriorityProjectionLabel>
                        <PriorityProjectionValue>{proposedCompletionLabel}</PriorityProjectionValue>
                        <PriorityProjectionMeta>
                          Based on {formData.priorityName} priority ({Number(formData.hoursDelay)} hour target).
                        </PriorityProjectionMeta>
                      </PriorityProjectionCard>
                    )}
                  </Field>
                )}
              </SectionBody>
            </SectionRow>

            {isRecurringService && (
              <SectionRow>
                <SectionMeta>
                  <SectionIndex>02C</SectionIndex>
                  <SectionTitle>Schedule</SectionTitle>
                  <SectionHelper>
                    Define recurring cadence, selected locations, scheduled dates, and assigned resources.
                  </SectionHelper>
                </SectionMeta>
                <SectionBody>
                  <Field>
                    <FieldLabel>Schedule *</FieldLabel>
                    {/* <FieldHelper>
                      Default setup assigns one resource and one date to all locations, with optional per-location
                      overrides.
                    </FieldHelper> */}
                    <FieldSelectionButton
                      type="button"
                      disabled={isVerifyMode || !clientId}
                      onClick={() => setIsRecurringScheduleModalOpen(true)}
                    >
                      <FieldSelectionText>
                        {formData.recurringSchedule ? "Edit recurring schedule" : "Configure recurring schedule"}
                      </FieldSelectionText>
                      <FieldSelectionChevron>›</FieldSelectionChevron>
                    </FieldSelectionButton>

                    <RecurringSummaryCard $isConfigured={!!formData.recurringSchedule}>
                      <RecurringSummaryTitle>
                        {recurringScheduleLocationCount} location{recurringScheduleLocationCount === 1 ? "" : "s"}{" "}
                        selected
                      </RecurringSummaryTitle>
                      <RecurringSummaryText>{recurringScheduleSummary}</RecurringSummaryText>
                    </RecurringSummaryCard>
                  </Field>
                </SectionBody>
              </SectionRow>
            )}

            {/* ── 02B Related Resource (PRESERVED DESIGN AS REQUESTED) ── */}
            <SectionRow>
              <SectionMeta>
                <SectionIndex>02B</SectionIndex>
                <SectionTitle>Related Resource</SectionTitle>
                <SectionHelper>Optional. Tag the resource this work pertains to.</SectionHelper>
              </SectionMeta>
              <SectionBody>
                <Field>
                  <FieldLabel>Resource</FieldLabel>
                  {/* <FieldHelper>Who this job should go to.</FieldHelper> */}
                  <SegmentedRow>
                    {(["none", "vendor", "team_member"] as ResourceKind[]).map((kind) => {
                      const label = kind === "none" ? "None" : kind === "vendor" ? "Vendor" : "Team Member";
                      return (
                        <SegmentedButton
                          key={kind}
                          type="button"
                          disabled={isVerifyMode}
                          $isActive={resourceKind === kind}
                          onClick={() => {
                            if (kind === "none") {
                              setResourceKind("none");
                              setResourceId("");
                              setIsRelatedResourceModalOpen(false);
                              return;
                            }

                            setResourceKind(kind);
                            if (resourceKind !== kind) {
                              setResourceId("");
                            }
                            setIsRelatedResourceModalOpen(true);
                          }}
                        >
                          {label}
                        </SegmentedButton>
                      );
                    })}
                  </SegmentedRow>

                  {resourceKind !== "none" && (
                    <ResourceDropdownWrapper>
                      <ParentWorkOrderButton
                        type="button"
                        disabled={isVerifyMode}
                        onClick={() => setIsRelatedResourceModalOpen(true)}
                      >
                        <ParentWorkOrderButtonText>
                          {selectedResourceLabel ||
                            (resourceOptions.length === 0
                              ? `No ${resourceKind === "vendor" ? "vendors" : "team members"} on file`
                              : `Search and select ${resourceKind === "vendor" ? "vendor" : "team member"}...`)}
                        </ParentWorkOrderButtonText>
                        <ParentWorkOrderButtonChevron>›</ParentWorkOrderButtonChevron>
                      </ParentWorkOrderButton>
                      {!!resourceId && !isVerifyMode && (
                        <ClearParentLink type="button" onClick={() => setResourceId("")}>
                          Clear selected resource
                        </ClearParentLink>
                      )}
                    </ResourceDropdownWrapper>
                  )}
                </Field>
              </SectionBody>
            </SectionRow>

            {/* ── 03 Service Questions (conditional) ── */}
            {!!serviceTypeQuestions.length && (
              <SectionRow>
                <SectionMeta>
                  <SectionIndex>03</SectionIndex>
                  <SectionTitle>Service Questions</SectionTitle>
                </SectionMeta>
                <SectionBody>
                  {serviceTypeQuestions.map((question) => (
                    <ServiceTypeQuestion
                      key={question.id}
                      question={question}
                      formData={formData}
                      setFormData={setFormData}
                      disabled={isVerifyMode}
                    />
                  ))}
                </SectionBody>
              </SectionRow>
            )}

            {/* ── 03B Billing & Procurement (UPDATED COMPONENT BLOCK) ── */}
            {showBillingSection && !isRecurringService && (
              <SectionRow>
                <SectionMeta>
                  <SectionTitle>Billing & Procurement</SectionTitle>
                </SectionMeta>
                <SectionBody>
                  <Field>
                    <FieldLabel>Billable Type</FieldLabel>
                    {/* <FieldHelper>
                      KSI = KSI pays vendor, absorbs cost. Client = KSI pays vendor, bills client. Both = KSI pays
                      vendor, bills part to client.
                    </FieldHelper> */}
                    <SegmentedRow>
                      {[
                        { value: "not_billable", label: "Not Billable" },
                        { value: "ksi", label: "KSI" },
                        { value: "client", label: "Client" },
                        { value: "both", label: "Both" },
                      ].map((opt) => (
                        <SegmentedButton
                          key={opt.value}
                          type="button"
                          disabled={isVerifyMode}
                          $isActive={formData.billingType === opt.value}
                          onClick={() => setFormData((data) => ({ ...data, billingType: opt.value }))}
                        >
                          {opt.label}
                        </SegmentedButton>
                      ))}
                    </SegmentedRow>
                  </Field>

                  {isKsiOnly && (
                    <Field>
                      <FieldLabel>Estimated Cost</FieldLabel>
                      {/* <FieldHelper>What KSI expects the vendor to charge. Absorbed by KSI.</FieldHelper> */}
                      <FieldInput
                        type="number"
                        min={0}
                        step="0.01"
                        disabled={isVerifyMode}
                        placeholder="0.00"
                        value={formData.estimatedCost || ""}
                        onChange={(e) => setFormData((data) => ({ ...data, estimatedCost: e.target.value }))}
                      />
                    </Field>
                  )}

                  {isClientBilled && (
                    <>
                      {showVendorCost && (
                        <Field>
                          <FieldLabel>Vendor Cost</FieldLabel>
                          {/* <FieldHelper>What the vendor will invoice KSI.</FieldHelper> */}
                          <FieldInput
                            type="number"
                            min={0}
                            step="0.01"
                            disabled={isVerifyMode}
                            placeholder="0.00"
                            value={formData.vendorCost || ""}
                            onChange={(e) => {
                              const nextVendorCost = e.target.value;
                              setFormData((data) => ({
                                ...data,
                                vendorCost: nextVendorCost,
                                clientFixedAmount:
                                  getAutoCalculatedClientFixedAmount(nextVendorCost, data.clientMarkupPct) ??
                                  data.clientFixedAmount,
                              }));
                            }}
                          />
                        </Field>
                      )}

                      {isBoth && (
                        <Field>
                          <FieldLabel>Client Billing Mode</FieldLabel>
                          {/* <FieldHelper>How KSI bills this client.</FieldHelper> */}
                          <SegmentedRow>
                            {[
                              { value: "fixed", label: "Fixed" },
                              { value: "cost_plus", label: "Cost-plus" },
                            ].map((opt) => (
                              <SegmentedButton
                                key={opt.value}
                                type="button"
                                disabled={isVerifyMode}
                                $isActive={formData.clientBillingMode === opt.value}
                                onClick={() => setFormData((data) => ({ ...data, clientBillingMode: opt.value }))}
                              >
                                {opt.label}
                              </SegmentedButton>
                            ))}
                          </SegmentedRow>
                        </Field>
                      )}

                      {isClientOnly || formData.clientBillingMode === "fixed" ? (
                        <>
                          <Field>
                            <FieldLabel>Markup %</FieldLabel>
                            {/* <FieldHelper>
                              Applied to Vendor Cost to auto-calculate the fixed client billed amount.
                            </FieldHelper> */}
                            <FieldInput
                              type="number"
                              min={0}
                              step="0.01"
                              disabled={isVerifyMode}
                              placeholder="0"
                              value={formData.clientMarkupPct || ""}
                              onChange={(e) => {
                                const nextMarkupPct = e.target.value;
                                setFormData((data) => ({
                                  ...data,
                                  clientMarkupPct: nextMarkupPct,
                                  clientFixedAmount:
                                    getAutoCalculatedClientFixedAmount(data.vendorCost, nextMarkupPct) ??
                                    data.clientFixedAmount,
                                }));
                              }}
                            />
                          </Field>
                          <Field>
                            <FieldLabel>Client Billed Amount (Fixed)</FieldLabel>
                            {/* <FieldHelper>Whatever amount KSI agreed to bill the client.</FieldHelper> */}
                            <FieldInput
                              type="number"
                              min={0}
                              step="0.01"
                              disabled={isVerifyMode}
                              placeholder="0.00"
                              value={formData.clientFixedAmount || ""}
                              onChange={(e) => setFormData((data) => ({ ...data, clientFixedAmount: e.target.value }))}
                            />
                          </Field>
                        </>
                      ) : (
                        <Field>
                          <FieldLabel>Client Billed Amount (Cost-plus)</FieldLabel>
                          {costPlusPct == null ? (
                            <BillingNoticeBox>
                              No cost-plus rate on file for{" "}
                              <span className="font-semibold">{selectedClient?.name ?? "this client"}</span>. Use Fixed
                              mode, or update the client profile.
                            </BillingNoticeBox>
                          ) : (
                            <BillingDisplayBox>
                              <BillingAmountText>
                                {computedClientAmount?.amount != null ? fmtMoney(computedClientAmount.amount) : "—"}
                              </BillingAmountText>
                              <BillingDetailsMeta>
                                Vendor × (1 + {costPlusPct}%) · Rate from {selectedClient?.name ?? "client"} SLA · not
                                editable
                              </BillingDetailsMeta>
                            </BillingDisplayBox>
                          )}
                        </Field>
                      )}
                    </>
                  )}

                  {formData.billingType !== "not_billable" && formData.billingType && (
                    <>
                      <Field>
                        <FieldLabel>Client Approval</FieldLabel>
                        <SegmentedRow>
                          {[
                            { value: "not_required", label: "Not Required" },
                            { value: "pending", label: "Pending" },
                            { value: "approved", label: "Approved" },
                            { value: "declined", label: "Declined" },
                          ].map((opt) => (
                            <SegmentedButton
                              key={opt.value}
                              type="button"
                              disabled={isVerifyMode}
                              $isActive={formData.clientApprovalStatus === opt.value}
                              onClick={() => setFormData((data) => ({ ...data, clientApprovalStatus: opt.value }))}
                            >
                              {opt.label}
                            </SegmentedButton>
                          ))}
                        </SegmentedRow>
                      </Field>

                      <Field>
                        <FieldLabel>Client PO Number</FieldLabel>
                        {/* <FieldHelper>Optional. The client&apos;s reference number for this work.</FieldHelper> */}
                        <FieldInput
                          disabled={isVerifyMode}
                          placeholder="e.g. ANCHOR-2461"
                          value={formData.clientPoNumber || ""}
                          onChange={(e) => setFormData((data) => ({ ...data, clientPoNumber: e.target.value }))}
                        />
                      </Field>

                      <Field>
                        <FieldLabel>Requires Quote</FieldLabel>
                        {/* <FieldHelper>Launch quote generation and mark this work request as quote-required.</FieldHelper> */}
                        <GenerateQuoteButton
                          type="button"
                          disabled={isVerifyMode}
                          onClick={() => {
                            setFormData((data) => ({ ...data, requiresQuote: true }));
                            setIsQuoteModalVisible(true);
                          }}
                        >
                          Generate Quote
                        </GenerateQuoteButton>
                        {/* {formData.requiresQuote && (
                          <FieldHelper>This work request is marked as requiring a formal quote.</FieldHelper>
                        )} */}
                      </Field>
                    </>
                  )}
                </SectionBody>
              </SectionRow>
            )}

            {!isRecurringService && (
              <SectionRow>
                <SectionMeta>
                  <SectionIndex>05</SectionIndex>
                  <SectionTitle>Scheduling</SectionTitle>
                  <SectionHelper>Captured values are written to schedule fields on the work order.</SectionHelper>
                </SectionMeta>
                <SectionBody>
                  <Field>
                    <FieldLabel>Scheduled Start</FieldLabel>
                    <DateTimePickerWrapper>
                      <ReactDatePicker
                        selected={parseLocalDateTime(formData.schedstart)}
                        onChange={(date) =>
                          setFormData((data) => ({
                            ...data,
                            schedstart: formatDateTimeLocalValue(date as Date | null),
                          }))
                        }
                        showTimeSelect
                        timeIntervals={15}
                        dateFormat="MM/dd/yyyy h:mm aa"
                        placeholderText="Select date and time"
                        popperClassName="kw-datepicker-popper"
                        calendarClassName="kw-datepicker"
                        showPopperArrow={false}
                        disabled={isVerifyMode}
                        customInput={<DateTimePickerInput />}
                      />
                    </DateTimePickerWrapper>
                  </Field>

                  <Field>
                    <FieldLabel>Scheduled Finish</FieldLabel>
                    <DateTimePickerWrapper>
                      <ReactDatePicker
                        selected={parseLocalDateTime(formData.schedfinish)}
                        onChange={(date) =>
                          setFormData((data) => ({
                            ...data,
                            schedfinish: formatDateTimeLocalValue(date as Date | null),
                          }))
                        }
                        showTimeSelect
                        timeIntervals={15}
                        dateFormat="MM/dd/yyyy h:mm aa"
                        placeholderText="Select date and time"
                        popperClassName="kw-datepicker-popper"
                        calendarClassName="kw-datepicker"
                        showPopperArrow={false}
                        disabled={isVerifyMode}
                        customInput={<DateTimePickerInput />}
                      />
                    </DateTimePickerWrapper>
                  </Field>

                  <Field>
                    <FieldLabel>Actual Start</FieldLabel>
                    <DateTimePickerWrapper>
                      <ReactDatePicker
                        selected={parseLocalDateTime(formData.actstart)}
                        onChange={(date) =>
                          setFormData((data) => ({ ...data, actstart: formatDateTimeLocalValue(date as Date | null) }))
                        }
                        showTimeSelect
                        timeIntervals={15}
                        dateFormat="MM/dd/yyyy h:mm aa"
                        placeholderText="Select date and time"
                        popperClassName="kw-datepicker-popper"
                        calendarClassName="kw-datepicker"
                        showPopperArrow={false}
                        disabled={isVerifyMode}
                        customInput={<DateTimePickerInput />}
                      />
                    </DateTimePickerWrapper>
                  </Field>

                  <Field>
                    <FieldLabel>Actual Finish</FieldLabel>
                    <DateTimePickerWrapper>
                      <ReactDatePicker
                        selected={parseLocalDateTime(formData.actfinish)}
                        onChange={(date) =>
                          setFormData((data) => ({ ...data, actfinish: formatDateTimeLocalValue(date as Date | null) }))
                        }
                        showTimeSelect
                        timeIntervals={15}
                        dateFormat="MM/dd/yyyy h:mm aa"
                        placeholderText="Select date and time"
                        popperClassName="kw-datepicker-popper"
                        calendarClassName="kw-datepicker"
                        showPopperArrow={false}
                        disabled={isVerifyMode}
                        customInput={<DateTimePickerInput />}
                      />
                    </DateTimePickerWrapper>
                  </Field>
                </SectionBody>
              </SectionRow>
            )}

            {/* ── 06 Control ── */}
            <SectionRow>
              <SectionMeta>
                <SectionIndex>06</SectionIndex>
                <SectionTitle>Control</SectionTitle>
              </SectionMeta>
              <SectionBody>
                {/* <Field>
                  <FieldLabel>Requestor Details</FieldLabel>
                  <FieldHelper>Enter the requestor details for this work request.</FieldHelper>
                  <RequestorDetailsGrid>
                    <Field>
                      <FieldLabel>First Name</FieldLabel>
                      <FieldInput
                        disabled={isVerifyMode}
                        placeholder="Enter first name"
                        value={formData.requestorFirstName || ""}
                        onChange={(e) => setFormData((data) => ({ ...data, requestorFirstName: e.target.value }))}
                      />
                    </Field>
                    <Field>
                      <FieldLabel>Last Name</FieldLabel>
                      <FieldInput
                        disabled={isVerifyMode}
                        placeholder="Enter last name"
                        value={formData.requestorLastName || ""}
                        onChange={(e) => setFormData((data) => ({ ...data, requestorLastName: e.target.value }))}
                      />
                    </Field>
                    <Field>
                      <FieldLabel>Email</FieldLabel>
                      <FieldInput
                        disabled={isVerifyMode}
                        placeholder="Enter email"
                        value={formData.requestorEmail || ""}
                        onChange={(e) => setFormData((data) => ({ ...data, requestorEmail: e.target.value }))}
                      />
                    </Field>
                    <Field>
                      <FieldLabel>Phone Number</FieldLabel>
                      <FieldInput
                        inputMode="numeric"
                        pattern="[0-9]*"
                        disabled={isVerifyMode}
                        placeholder="Enter phone number"
                        value={formData.requestorPhoneNumber || ""}
                        onChange={(e) =>
                          setFormData((data) => ({ ...data, requestorPhoneNumber: toDigitsOnly(e.target.value) }))
                        }
                      />
                    </Field>
                  </RequestorDetailsGrid>
                </Field> */}

                <Field>
                  <FieldLabel>Parent Work Order</FieldLabel>
                  {/* <FieldHelper>
                    Optional. Search by work order number or title and select from the same table columns used in Work
                    Requests.
                  </FieldHelper> */}
                  <ParentWorkOrderButton
                    type="button"
                    // disabled={isVerifyMode || !clientId}
                    onClick={() => setIsParentModalOpen(true)}
                  >
                    <ParentWorkOrderButtonText>
                      {selectedParentWorkOrder
                        ? `${selectedParentWorkOrder.wonum}: ${selectedParentWorkOrder.description || selectedParentWorkOrder.name || "Untitled work order"}`
                        : "Search and select parent work order..."}
                    </ParentWorkOrderButtonText>
                    <ParentWorkOrderButtonChevron>›</ParentWorkOrderButtonChevron>
                  </ParentWorkOrderButton>
                  {!!formData.parentWorkOrder && !isVerifyMode && (
                    <ClearParentLink
                      type="button"
                      onClick={() => setFormData((data) => ({ ...data, parentWorkOrder: "" }))}
                    >
                      Clear selected parent
                    </ClearParentLink>
                  )}
                </Field>

                {/* <Field>
                  <FieldLabel>Customer reference / PO number</FieldLabel>
                  <FieldHelper>
                    Separate Jira task set up for how to set up Purchasing (POs). Customer&apos;s own order reference
                    for their records
                  </FieldHelper>
                  <FieldInput
                    disabled={isVerifyMode}
                    placeholder="e.g. PO-123456"
                    value={formData.customerPo || ""}
                    onChange={(e) => setFormData((data) => ({ ...data, customerPo: e.target.value }))}
                  />
                </Field> */}

                {customWorkRequestFields && (
                  <CustomWorkRequestFieldsForm
                    customWorkRequestFields={customWorkRequestFields[clientId] ?? []}
                    $isMobile={false}
                    form={form}
                    isPublic={false}
                    isClient={false}
                  />
                )}

                <Field>
                  <FieldLabel>High Risk Classification</FieldLabel>
                  {/* <FieldHelper>
                    Selected classification will be reused later for escalation and workflow routing.
                  </FieldHelper> */}
                  <FieldSelectionButton
                    type="button"
                    disabled={isVerifyMode}
                    onClick={() => setIsHighRiskClassificationModalOpen(true)}
                  >
                    <FieldSelectionText>
                      {highRiskClassificationLabel
                        ? `${highRiskServiceTypeLabel ? `${highRiskServiceTypeLabel} / ` : ""}${highRiskClassificationLabel}`
                        : "Select high risk classification..."}
                    </FieldSelectionText>
                    <FieldSelectionChevron>›</FieldSelectionChevron>
                  </FieldSelectionButton>
                </Field>

                <WorkRequestTargetDatesInput
                  isVerifyMode={isVerifyMode}
                  maximoTimezone={maximoTimezone}
                  targetFinish={targetFinish}
                  targetStart={targetStart}
                  timezone={timezone}
                />

                {!!error && <InlineError>{error}</InlineError>}

                <ActionsRow>
                  <Button text="Cancel" variant="secondary" onClick={onExitClick} />
                  <PrimaryActionButton
                    type="button"
                    disabled={buttonDisabledConditions || isLoading}
                    onClick={(e) => onConfirmClick(e as React.MouseEvent<HTMLButtonElement>)}
                  >
                    {isLoading ? "Submitting..." : isRecurringService ? "Submit Recurring Service" : "Submit Request"}
                  </PrimaryActionButton>
                </ActionsRow>
              </SectionBody>
            </SectionRow>

            <SectionRow>
              <SectionMeta>
                <SectionIndex>07</SectionIndex>
                <SectionTitle>Requestor</SectionTitle>
              </SectionMeta>
              <SectionBody>
                <Field>
                  <FieldLabel>Requestor Details</FieldLabel>
                  {/* <FieldHelper>Enter the requestor details for this work request.</FieldHelper> */}
                  <RequestorDetailsGrid>
                    <Field>
                      <FieldLabel>First Name</FieldLabel>
                      <FieldInput
                        disabled={isVerifyMode}
                        placeholder="Enter first name"
                        value={formData.requestorFirstName || ""}
                        onChange={(e) => setFormData((data) => ({ ...data, requestorFirstName: e.target.value }))}
                      />
                    </Field>
                    <Field>
                      <FieldLabel>Last Name</FieldLabel>
                      <FieldInput
                        disabled={isVerifyMode}
                        placeholder="Enter last name"
                        value={formData.requestorLastName || ""}
                        onChange={(e) => setFormData((data) => ({ ...data, requestorLastName: e.target.value }))}
                      />
                    </Field>
                    <Field>
                      <FieldLabel>Email</FieldLabel>
                      <FieldInput
                        disabled={isVerifyMode}
                        placeholder="Enter email"
                        value={formData.requestorEmail || ""}
                        onChange={(e) => setFormData((data) => ({ ...data, requestorEmail: e.target.value }))}
                      />
                    </Field>
                    <Field>
                      <FieldLabel>Phone Number</FieldLabel>
                      <FieldInput
                        inputMode="numeric"
                        pattern="[0-9]*"
                        disabled={isVerifyMode}
                        placeholder="Enter phone number"
                        value={formData.requestorPhoneNumber || ""}
                        onChange={(e) =>
                          setFormData((data) => ({ ...data, requestorPhoneNumber: toDigitsOnly(e.target.value) }))
                        }
                      />
                    </Field>
                  </RequestorDetailsGrid>
                </Field>
              </SectionBody>
            </SectionRow>
          </PageRoot>
        </ContentFrame>
      </Content>
    </Container>
  );
};

// ─── Styled Components ───────────────────────────────────────────────────────

const PageRoot = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  padding-bottom: 32px;
`;

const HeaderArea = styled.div`
  padding-bottom: 24px;
  border-bottom: 1px solid #dde2e7;
`;

const EyebrowText = styled.div`
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6f7782;
`;

const PageTitle = styled.h1`
  margin: 8px 0 0;
  font-size: 40px;
  line-height: 1.1;
  font-weight: 600;
  color: #1f2a37;
`;

const PageSubtitle = styled.p`
  margin: 8px 0 0;
  font-size: 13px;
  color: #6f7782;
`;

const ServiceModeToggleRow = styled.div`
  margin-top: 18px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const ServiceModeButton = styled.button<{ $isActive: boolean }>`
  border: 1px solid ${({ $isActive }) => ($isActive ? "#1f2a37" : "#c9d2dc")};
  background: ${({ $isActive }) => ($isActive ? "#1f2a37" : "#ffffff")};
  color: ${({ $isActive }) => ($isActive ? "#ffffff" : "#1f2a37")};
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const SectionRow = styled.section`
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 48px;
  padding: 40px 0;
  border-top: 1px solid #dde2e7;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const SectionMeta = styled.div``;

const SectionIndex = styled.div`
  font-size: 11px;
  color: #6f7782;
  letter-spacing: 0.04em;
`;

const SectionTitle = styled.h2`
  margin: 8px 0 0;
  font-size: 20px;
  line-height: 1.25;
  color: #1f2a37;
`;

const SectionHelper = styled.p`
  margin: 8px 0 0;
  font-size: 12px;
  font-weight: 300;
  color: #6f7782;
  line-height: 1.5;
`;

const SectionBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

const Field = styled.div``;

const RequestorDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

const FieldLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #1f2a37;
  font-weight: 600;
`;

// const FieldHelper = styled.p`
//   margin: -4px 0 12px;
//   font-size: 12px;
//   font-weight: 300;
//   color: #6f7782;
//   line-height: 1.5;
// `;

const FieldInput = styled.input`
  width: 100%;
  border: 1px solid #c9d2dc;
  padding: 14px 16px;
  font-size: 14px;
  background: #ffffff;

  &:focus {
    outline: 1px solid #1f2a37;
    outline-offset: -1px;
  }
`;

const DateTimePickerWrapper = styled.div`
  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    display: block;
  }

  .kw-datepicker-popper {
    z-index: 4;
  }

  .kw-datepicker {
    border: 1px solid #c9d2dc;
    border-radius: 0;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.1);
    font-family: inherit;
  }

  .kw-datepicker .react-datepicker__header {
    background: #f7f8fa;
    border-bottom: 1px solid #e3e8ee;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .kw-datepicker .react-datepicker__current-month,
  .kw-datepicker .react-datepicker-time__header,
  .kw-datepicker .react-datepicker-year-header {
    color: #1f2a37;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .kw-datepicker .react-datepicker__day-name,
  .kw-datepicker .react-datepicker__day,
  .kw-datepicker .react-datepicker__time-name {
    color: #1f2a37;
    width: 2rem;
    line-height: 2rem;
    margin: 0.18rem;
  }

  .kw-datepicker .react-datepicker__day:hover,
  .kw-datepicker .react-datepicker__time-list-item:hover {
    background: #eef2f6;
  }

  .kw-datepicker .react-datepicker__day--selected,
  .kw-datepicker .react-datepicker__day--keyboard-selected,
  .kw-datepicker .react-datepicker__time-list-item--selected {
    background: #1f2a37;
    color: #ffffff;
    font-weight: 600;
  }

  .kw-datepicker .react-datepicker__time-container {
    border-left: 1px solid #e3e8ee;
  }

  .kw-datepicker .react-datepicker__time-box {
    width: 7.5rem;
  }

  .kw-datepicker .react-datepicker__time-list {
    padding: 6px 0;
  }

  .kw-datepicker .react-datepicker__time-list-item {
    height: 2.2rem !important;
    line-height: 2.2rem !important;
    margin: 0;
    padding: 0 10px;
    font-size: 13px;
  }

  .kw-datepicker .react-datepicker__navigation-icon::before {
    border-color: #6f7782;
  }
`;

const FieldTextArea = styled.textarea`
  width: 100%;
  min-height: 140px;
  border: 1px solid #c9d2dc;
  padding: 14px 16px;
  font-size: 14px;
  resize: vertical;

  &:focus {
    outline: 1px solid #1f2a37;
    outline-offset: -1px;
  }
`;

// const FieldSelect = styled.select`
//   width: 100%;
//   border: 1px solid #c9d2dc;
//   padding: 14px 16px;
//   font-size: 14px;
//   background: #ffffff;

//   &:focus {
//     outline: 1px solid #1f2a37;
//     outline-offset: -1px;
//   }
// `;

const FieldSelectionButton = styled.button`
  width: 100%;
  border: 1px solid #c9d2dc;
  background: #ffffff;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: #1f2a37;
    background: #f9fafb;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:focus {
    outline: 1px solid #1f2a37;
    outline-offset: -1px;
  }
`;

const FieldSelectionText = styled.span`
  font-size: 14px;
  color: #1f2a37;
  text-align: left;
  flex: 1;
`;

const FieldSelectionChevron = styled.span`
  font-size: 18px;
  color: #c9d2dc;
`;

const ParentWorkOrderButton = styled.button`
  width: 100%;
  border: 1px solid #c9d2dc;
  background: #ffffff;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: #1f2a37;
    background: #f9fafb;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:focus {
    outline: 1px solid #1f2a37;
    outline-offset: -1px;
  }
`;

const ParentWorkOrderButtonText = styled.span`
  font-size: 14px;
  color: #1f2a37;
  text-align: left;
  flex: 1;
`;

const ParentWorkOrderButtonChevron = styled.span`
  font-size: 18px;
  color: #c9d2dc;
`;

const ClearParentLink = styled.button`
  margin-top: 10px;
  border: none;
  background: transparent;
  color: #6f7782;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  cursor: pointer;
  padding: 0;

  &:hover {
    color: #1f2a37;
  }
`;

const SegmentedRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const PriorityProjectionCard = styled.div`
  margin-top: 14px;
  border: 1px solid #dde2e7;
  background: #f9fafb;
  padding: 12px 14px;
`;

const PriorityProjectionLabel = styled.div`
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6f7782;
  margin-bottom: 6px;
`;

const PriorityProjectionValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1f2a37;
`;

const PriorityProjectionMeta = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: #6f7782;
`;

const RecurringSummaryCard = styled.div<{ $isConfigured: boolean }>`
  margin-top: 14px;
  border: 1px solid ${({ $isConfigured }) => ($isConfigured ? "#1f2a37" : "#dde2e7")};
  background: ${({ $isConfigured }) => ($isConfigured ? "#f6f8fa" : "#f9fafb")};
  padding: 12px 14px;
`;

const RecurringSummaryTitle = styled.div`
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6f7782;
  margin-bottom: 6px;
`;

const RecurringSummaryText = styled.div`
  font-size: 13px;
  color: #1f2a37;
`;

const SegmentedButton = styled.button<{ $isActive: boolean }>`
  border: 1px solid ${({ $isActive }) => ($isActive ? "#1f2a37" : "#c9d2dc")};
  background: ${({ $isActive }) => ($isActive ? "#1f2a37" : "#ffffff")};
  color: ${({ $isActive }) => ($isActive ? "#ffffff" : "#1f2a37")};
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;

const ResourceDropdownWrapper = styled.div`
  margin-top: 16px;
`;

// const CheckboxLabel = styled.label`
//   display: flex;
//   align-items: center;
//   gap: 12px;
//   cursor: pointer;
//   user-select: none;

//   input {
//     width: 16px;
//     height: 16px;
//     accent-color: #1f2a37;
//   }

//   span {
//     font-size: 13px;
//     font-weight: 300;
//     color: #1f2a37;
//   }
// `;

const GenerateQuoteButton = styled.button`
  border: 1px solid #1f2a37;
  background: #1f2a37;
  color: #ffffff;
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    border-color: #c9d2dc;
    background: #c9d2dc;
  }
`;

const QuoteModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const QuoteModalCard = styled.div`
  width: min(1100px, 100%);
  max-height: 92vh;
  overflow: auto;
  background: #ffffff;
  border: 1px solid #c9d2dc;
`;

const QuoteModalHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
  background: #ffffff;
  border-bottom: 1px solid #c9d2dc;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h3 {
    margin: 0;
    font-size: 18px;
    color: #1f2a37;
  }
`;

const QuoteModalCloseButton = styled.button`
  border: 1px solid #c9d2dc;
  background: #ffffff;
  color: #1f2a37;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 8px 12px;
  cursor: pointer;
`;

const QuoteModalBody = styled.div`
  padding: 16px;
`;

// ─── Custom Dynamic Billing Elements ─────────────────────────────────────────

const BillingNoticeBox = styled.div`
  border: 1px solid #1f2a37;
  background: #ffffff;
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 300;
  color: #1f2a37;

  .font-semibold {
    font-weight: 600;
  }
`;

const BillingDisplayBox = styled.div`
  border: 1px solid #c9d2dc;
  background: #f3f4f6;
  padding: 12px 16px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
`;

const BillingAmountText = styled.span`
  font-size: 18px;
  font-weight: 600;
  font-family: monospace;
  color: #1f2a37;
`;

const BillingDetailsMeta = styled.span`
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #6f7782;
`;

// ── Attachment drop-zone ──────────────────────────────────────────────────────

const AttachLabel = styled.label<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border: 1px dashed #c9d2dc;
  padding: 20px 16px;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};

  &:hover {
    border-color: #1f2a37;
  }
`;

const AttachText = styled.span`
  font-size: 13px;
  font-weight: 300;
  color: #6f7782;
`;

const AttachButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 10px 16px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  background: #1f2a37;
  color: #ffffff;
  border: 1px solid #1f2a37;
`;

const InlineError = styled.p`
  margin: 0;
  color: ${colors.red.default};
  font-size: 13px;
`;

// const VerifyRow = styled.label`
//   display: flex;
//   gap: 10px;
//   align-items: center;
//   font-size: 13px;
//   color: #1f2a37;

//   input {
//     width: 16px;
//     height: 16px;
//   }
// `;

const ActionsRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const PrimaryActionButton = styled.button`
  border: 1px solid #1f2a37;
  background: #1f2a37;
  color: #ffffff;
  padding: 12px 22px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: 600;

  &:disabled {
    border-color: #c9d2dc;
    background: #c9d2dc;
    cursor: not-allowed;
  }
`;

// ─── Client Location Modal Button ────────────────────────────────────────────────

const ClientLocationButton = styled.button<{ $isEmpty?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid ${({ $isEmpty }) => ($isEmpty ? "#c9d2dc" : "#c9d2dc")};
  padding: 14px 16px;
  font-size: 14px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.15s ease;
  text-align: left;

  &:hover:not(:disabled) {
    border-color: #1f2a37;
    background: #f9fafb;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:focus {
    outline: 1px solid #1f2a37;
    outline-offset: -1px;
  }
`;

const ClientLocationButtonText = styled.span`
  font-weight: 500;
  color: #1f2a37;
  flex: 1;
  min-width: 0;
`;

const ClientLocationButtonMeta = styled.span`
  font-size: 12px;
  color: #6f7782;
  flex-shrink: 0;
  white-space: nowrap;
`;

const ClientLocationButtonChevron = styled.span`
  font-size: 18px;
  color: #c9d2dc;
  flex-shrink: 0;
`;

export default ManagerCreateFormFields;
